import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-nocheck
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import Avatar from 'flarum/common/components/Avatar';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import SubmitDecorationModal from './SubmitDecorationModal';
import { pointsLabel } from '../../common/utils/pointsLabel';
import { safeCssUrl } from '../../common/utils/safeCssUrl';
/**
 * Page that lists what the current user already owns and lets them switch
 * between owned decorations / unequip.
 */
export default class DecorationsPage extends Page {
  constructor() {
    super(...arguments);
    // Track which specific row is busy (key = `${type}:${id}` or `${type}:unequip`)
    // so we don't show spinners on every button while one is mid-request.
    _defineProperty(this, "busy", new Set());
  }
  // Active section is derived from the route param `tab` so each section has
  // its own URL (/decorations/name, /decorations/cover). The bare path falls
  // back to 'avatar'.
  get tab() {
    const raw = m.route.param('tab');
    const valid = ['all', 'avatar', 'name', 'cover', 'title', 'post-hl'];
    if (valid.includes(raw)) {
      // Reject a tab whose master toggle is off — the section won't
      // render anyway and the user would see an empty page. Fall
      // through to 'all' so they at least see what they own.
      const attr = k => app.forum.attribute(k) !== false;
      const enabledKey = {
        avatar: 'pointSystem.avatar_deco_enabled',
        name: 'pointSystem.name_deco_enabled',
        cover: 'pointSystem.cover_deco_enabled',
        title: 'pointSystem.title_deco_enabled',
        'post-hl': 'pointSystem.post_hl_deco_enabled',
        all: null
      }[raw];
      if (!enabledKey || attr(enabledKey)) return raw;
    }
    return 'all';
  }
  busyKey(type, id) {
    return "".concat(type, ":").concat(id);
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.session.user) {
      m.route.set('/');
    }
    const title = app.translator.trans('ramon-point-system.forum.my_decorations.title');
    app.history.push('decorations', title);
    app.setTitle(title);
  }
  view() {
    var _app$session$user$att, _app$session$user$att2, _app$session$user$att3, _app$session$user$att4, _app$session$user$att5;
    if (!app.session.user) return null;
    const avatars = app.forum.attribute('pointSystemAvatarDecorations') || [];
    const names = app.forum.attribute('pointSystemNameDecorations') || [];
    const covers = app.forum.attribute('pointSystemCoverDecorations') || [];
    const titles = app.forum.attribute('pointSystemTitleDecorations') || [];
    const postHls = app.forum.attribute('pointSystemPostHighlightDecorations') || [];
    const owned = app.session.user.attribute('ownedDecorationIds') || [];

    // Attach `_quantity` from the owned array so the render layer can show
    // a stack-count badge (×N) without a second lookup. Claims are now
    // stackable — a user may own multiple copies of the same decoration
    // via repeat shop purchases, admin grants, or accumulated trades.
    const ownedOf = (type, source) => source.filter(d => owned.some(o => o.type === type && Number(o.id) === Number(d.id))).map(d => {
      var _o$quantity;
      const o = owned.find(o => o.type === type && Number(o.id) === Number(d.id));
      return _objectSpread(_objectSpread({}, d), {}, {
        _quantity: Math.max(1, Number((_o$quantity = o == null ? void 0 : o.quantity) != null ? _o$quantity : 1))
      });
    });
    const ownedAvatars = ownedOf('avatar_decoration', avatars);
    const ownedNames = ownedOf('name_decoration', names);
    const ownedCovers = ownedOf('cover_decoration', covers);
    const ownedTitles = ownedOf('title_decoration', titles);
    const ownedPostHls = ownedOf('post_highlight_decoration', postHls);
    const equippedAvatarId = Number((_app$session$user$att = app.session.user.attribute('equippedAvatarDecorationId')) != null ? _app$session$user$att : 0);
    const equippedNameId = Number((_app$session$user$att2 = app.session.user.attribute('equippedNameDecorationId')) != null ? _app$session$user$att2 : 0);
    const equippedCoverId = Number((_app$session$user$att3 = app.session.user.attribute('equippedCoverDecorationId')) != null ? _app$session$user$att3 : 0);
    const equippedTitleId = Number((_app$session$user$att4 = app.session.user.attribute('equippedTitleDecorationId')) != null ? _app$session$user$att4 : 0);
    const equippedPostHlId = Number((_app$session$user$att5 = app.session.user.attribute('equippedPostHighlightDecorationId')) != null ? _app$session$user$att5 : 0);
    const user = app.session.user;
    const equippedNameSlug = String(user.attribute('equippedNameDecorationSlug') || '').replace(/[^a-zA-Z0-9_-]/g, '');
    const avatarEnabled = app.forum.attribute('pointSystem.avatar_deco_enabled') !== false;
    const nameEnabled = app.forum.attribute('pointSystem.name_deco_enabled') !== false;
    const coverEnabled = app.forum.attribute('pointSystem.cover_deco_enabled') !== false;
    const titleEnabled = app.forum.attribute('pointSystem.title_deco_enabled') !== false;
    const postHlEnabled = app.forum.attribute('pointSystem.post_hl_deco_enabled') !== false;
    const submitType = this.currentSubmitType();
    const userSubmissionsEnabled = app.forum.attribute('pointSystemUserSubmissionsEnabled') !== false && app.forum.attribute('pointSystemUserSubmissionsEnabled') !== undefined;
    const canSubmit = userSubmissionsEnabled && submitType !== null;
    return m("div", {
      className: "PointSystemDecorations container"
    }, m("div", {
      className: "PointSystemDecorations-pageHeader"
    }, m("h1", null, app.translator.trans('ramon-point-system.forum.my_decorations.title')), m("div", {
      className: "PointSystemDecorations-pageHeader-actions"
    }, app.forum.attribute('pointSystemCanViewShop') && m(LinkButton, {
      href: app.route('pointSystem.shop'),
      icon: "fas fa-arrow-left",
      className: "Button Button--link PointSystemDecorations-back"
    }, app.translator.trans('ramon-point-system.forum.my_decorations.back_to_shop')), canSubmit && m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(SubmitDecorationModal, {
        type: submitType,
        onSubmitted: () => m.redraw()
      })
    }, m("i", {
      className: "fas fa-paper-plane"
    }), " ", app.translator.trans('ramon-point-system.forum.my_decorations.submit_cta')))), this.renderLivePreview(user, equippedNameSlug), m("nav", {
      className: "PointSystemDecorations-nav"
    }, m("ul", null, m("li", null, m(SelectDropdown, {
      className: "PointSystemDecorations-nav-select App-titleControl",
      buttonClassName: "Button",
      accessibleToggleLabel: app.translator.trans('ramon-point-system.forum.my_decorations.toggle_nav_label')
    }, this.navItems(avatarEnabled, nameEnabled, coverEnabled, titleEnabled, postHlEnabled))))), this.tab === 'all' && m("section", null, m("h2", null, app.translator.trans('ramon-point-system.forum.my_decorations.tab_all')), ownedAvatars.length + ownedNames.length + ownedCovers.length + ownedTitles.length + ownedPostHls.length === 0 && m("p", {
      className: "PointSystemDecorations-empty"
    }, app.translator.trans('ramon-point-system.forum.my_decorations.none')), ownedAvatars.length > 0 && avatarEnabled && m("div", {
      className: "PointSystemDecorations-allGroup"
    }, m("h3", null, app.translator.trans('ramon-point-system.forum.my_decorations.avatar')), m("div", {
      className: "PointSystemDecorations-grid"
    }, ownedAvatars.map(d => m("div", {
      className: "PointSystemDecorations-item ".concat(equippedAvatarId === d.id ? 'is-equipped' : ''),
      key: "all-av-".concat(d.id)
    }, this.avatarPreview(d), m("div", {
      className: "PointSystemDecorations-item-name"
    }, d.name, d._quantity > 1 && m("span", {
      className: "PointSystemDecorations-item-quantity"
    }, "\xD7", d._quantity)), m("div", {
      className: "PointSystemDecorations-item-actions"
    }, equippedAvatarId === d.id ? m(Button, {
      className: "Button",
      loading: this.busy.has(this.busyKey('avatar_decoration', d.id)),
      onclick: () => this.unequip('avatar_decoration', d.id)
    }, app.translator.trans('ramon-point-system.forum.my_decorations.unequip')) : m(Button, {
      className: "Button Button--primary",
      loading: this.busy.has(this.busyKey('avatar_decoration', d.id)),
      onclick: () => this.equip('avatar_decoration', d.id, {
        equippedAvatarDecorationId: d.id,
        equippedAvatarDecorationUrl: d.imageUrl || d.imagePath
      })
    }, app.translator.trans('ramon-point-system.forum.my_decorations.equip'))))))), ownedNames.length > 0 && nameEnabled && m("div", {
      className: "PointSystemDecorations-allGroup"
    }, m("h3", null, app.translator.trans('ramon-point-system.forum.my_decorations.name')), m("div", {
      className: "PointSystemDecorations-grid"
    }, ownedNames.map(d => {
      const slug = String(d.slug || '').replace(/[^a-zA-Z0-9_-]/g, '');
      return m("div", {
        className: "PointSystemDecorations-item ".concat(equippedNameId === d.id ? 'is-equipped' : ''),
        key: "all-na-".concat(d.id)
      }, m("span", {
        className: "ps-name-preview ps-name-".concat(slug)
      }, app.session.user.username()), m("div", {
        className: "PointSystemDecorations-item-name"
      }, d.name, d._quantity > 1 && m("span", {
        className: "PointSystemDecorations-item-quantity"
      }, "\xD7", d._quantity)), m("div", {
        className: "PointSystemDecorations-item-actions"
      }, equippedNameId === d.id ? m(Button, {
        className: "Button",
        loading: this.busy.has(this.busyKey('name_decoration', d.id)),
        onclick: () => this.unequip('name_decoration', d.id)
      }, app.translator.trans('ramon-point-system.forum.my_decorations.unequip')) : m(Button, {
        className: "Button Button--primary",
        loading: this.busy.has(this.busyKey('name_decoration', d.id)),
        onclick: () => this.equip('name_decoration', d.id, {
          equippedNameDecorationId: d.id,
          equippedNameDecorationSlug: d.slug
        })
      }, app.translator.trans('ramon-point-system.forum.my_decorations.equip'))));
    }))), ownedCovers.length > 0 && coverEnabled && m("div", {
      className: "PointSystemDecorations-allGroup"
    }, m("h3", null, app.translator.trans('ramon-point-system.forum.my_decorations.cover')), m("div", {
      className: "PointSystemDecorations-coverGrid"
    }, ownedCovers.map(d => m("div", {
      className: "PointSystemDecorations-coverItem ".concat(equippedCoverId === d.id ? 'is-equipped' : ''),
      key: "all-co-".concat(d.id)
    }, m("div", {
      className: "PointSystemDecorations-coverItem-preview"
    }, m("img", {
      src: this.resolveAsset(d.imagePath || d.imageUrl),
      alt: d.name
    })), m("div", {
      className: "PointSystemDecorations-item-name"
    }, d.name, d._quantity > 1 && m("span", {
      className: "PointSystemDecorations-item-quantity"
    }, "\xD7", d._quantity)), m("div", {
      className: "PointSystemDecorations-item-actions"
    }, equippedCoverId === d.id ? m(Button, {
      className: "Button",
      loading: this.busy.has(this.busyKey('cover_decoration', d.id)),
      onclick: () => this.unequip('cover_decoration', d.id)
    }, app.translator.trans('ramon-point-system.forum.my_decorations.unequip')) : m(Button, {
      className: "Button Button--primary",
      loading: this.busy.has(this.busyKey('cover_decoration', d.id)),
      onclick: () => this.equip('cover_decoration', d.id, {
        equippedCoverDecorationId: d.id,
        equippedCoverDecorationUrl: d.imageUrl || d.imagePath
      })
    }, app.translator.trans('ramon-point-system.forum.my_decorations.equip'))))))), ownedTitles.length > 0 && titleEnabled && m("div", {
      className: "PointSystemDecorations-allGroup"
    }, m("h3", null, app.translator.trans('ramon-point-system.forum.my_decorations.custom_title')), m("div", {
      className: "PointSystemDecorations-grid"
    }, ownedTitles.map(d => {
      const slug = String(d.slug || '').replace(/[^a-zA-Z0-9_-]/g, '');
      const isEq = equippedTitleId === d.id;
      const styleVar = d.color ? "--ps-title-color:".concat(String(d.color).replace(/[<>"';]/g, ''), ";") : '';
      return m("div", {
        className: "PointSystemDecorations-item ".concat(isEq ? 'is-equipped' : ''),
        key: "all-ti-".concat(d.id)
      }, m("span", {
        className: "ps-title-preview ps-title-".concat(slug),
        style: styleVar
      }, d.titleText), m("div", {
        className: "PointSystemDecorations-item-name"
      }, d.name, d._quantity > 1 && m("span", {
        className: "PointSystemDecorations-item-quantity"
      }, "\xD7", d._quantity)), m("div", {
        className: "PointSystemDecorations-item-actions"
      }, isEq ? m(Button, {
        className: "Button",
        loading: this.busy.has(this.busyKey('title_decoration', d.id)),
        onclick: () => this.unequip('title_decoration', d.id)
      }, app.translator.trans('ramon-point-system.forum.my_decorations.unequip')) : m(Button, {
        className: "Button Button--primary",
        loading: this.busy.has(this.busyKey('title_decoration', d.id)),
        onclick: () => this.equip('title_decoration', d.id, {
          equippedTitleDecorationId: d.id,
          equippedTitleDecorationSlug: d.slug,
          equippedTitleDecorationText: d.titleText
        })
      }, app.translator.trans('ramon-point-system.forum.my_decorations.equip'))));
    }))), ownedPostHls.length > 0 && postHlEnabled && m("div", {
      className: "PointSystemDecorations-allGroup"
    }, m("h3", null, app.translator.trans('ramon-point-system.forum.my_decorations.post_hl')), m("div", {
      className: "PointSystemDecorations-grid"
    }, ownedPostHls.map(d => {
      const slug = String(d.slug || '').replace(/[^a-zA-Z0-9_-]/g, '');
      const isEq = equippedPostHlId === d.id;
      return m("div", {
        className: "PointSystemDecorations-item ".concat(isEq ? 'is-equipped' : ''),
        key: "all-ph-".concat(d.id)
      }, m("div", {
        className: "ps-posthl-preview ps-posthl-".concat(slug)
      }, m("div", {
        className: "ps-posthl-preview-avatar"
      }), m("div", {
        className: "ps-posthl-preview-body"
      }, m("div", {
        className: "ps-posthl-preview-line"
      }), m("div", {
        className: "ps-posthl-preview-line short"
      }))), m("div", {
        className: "PointSystemDecorations-item-name"
      }, d.name, d._quantity > 1 && m("span", {
        className: "PointSystemDecorations-item-quantity"
      }, "\xD7", d._quantity)), m("div", {
        className: "PointSystemDecorations-item-actions"
      }, isEq ? m(Button, {
        className: "Button",
        loading: this.busy.has(this.busyKey('post_highlight_decoration', d.id)),
        onclick: () => this.unequip('post_highlight_decoration', d.id)
      }, app.translator.trans('ramon-point-system.forum.my_decorations.unequip')) : m(Button, {
        className: "Button Button--primary",
        loading: this.busy.has(this.busyKey('post_highlight_decoration', d.id)),
        onclick: () => this.equip('post_highlight_decoration', d.id, {
          equippedPostHighlightDecorationId: d.id,
          equippedPostHighlightDecorationSlug: d.slug
        })
      }, app.translator.trans('ramon-point-system.forum.my_decorations.equip'))));
    })))), this.tab === 'avatar' && avatarEnabled && m("section", null, m("h2", null, app.translator.trans('ramon-point-system.forum.my_decorations.avatar')), ownedAvatars.length === 0 && m("p", {
      className: "PointSystemDecorations-empty"
    }, app.translator.trans('ramon-point-system.forum.my_decorations.none')), m("div", {
      className: "PointSystemDecorations-grid"
    }, ownedAvatars.map(d => m("div", {
      className: "PointSystemDecorations-item ".concat(equippedAvatarId === d.id ? 'is-equipped' : ''),
      key: "av-".concat(d.id)
    }, this.avatarPreview(d), m("div", {
      className: "PointSystemDecorations-item-name"
    }, d.name, d._quantity > 1 && m("span", {
      className: "PointSystemDecorations-item-quantity"
    }, "\xD7", d._quantity)), m("div", {
      className: "PointSystemDecorations-item-actions"
    }, equippedAvatarId === d.id ? m(Button, {
      className: "Button",
      loading: this.busy.has(this.busyKey('avatar_decoration', d.id)),
      onclick: () => this.unequip('avatar_decoration', d.id)
    }, app.translator.trans('ramon-point-system.forum.my_decorations.unequip')) : m(Button, {
      className: "Button Button--primary",
      loading: this.busy.has(this.busyKey('avatar_decoration', d.id)),
      onclick: () => this.equip('avatar_decoration', d.id, {
        equippedAvatarDecorationId: d.id,
        equippedAvatarDecorationUrl: d.imageUrl || d.imagePath
      })
    }, app.translator.trans('ramon-point-system.forum.my_decorations.equip'))))))), this.tab === 'name' && nameEnabled && m("section", null, m("h2", null, app.translator.trans('ramon-point-system.forum.my_decorations.name')), ownedNames.length === 0 && m("p", {
      className: "PointSystemDecorations-empty"
    }, app.translator.trans('ramon-point-system.forum.my_decorations.none')), m("div", {
      className: "PointSystemDecorations-grid"
    }, ownedNames.map(d => {
      const slug = String(d.slug || '').replace(/[^a-zA-Z0-9_-]/g, '');
      return m("div", {
        className: "PointSystemDecorations-item ".concat(equippedNameId === d.id ? 'is-equipped' : ''),
        key: "na-".concat(d.id)
      }, m("span", {
        className: "ps-name-preview ps-name-".concat(slug)
      }, app.session.user.username()), m("div", {
        className: "PointSystemDecorations-item-name"
      }, d.name, d._quantity > 1 && m("span", {
        className: "PointSystemDecorations-item-quantity"
      }, "\xD7", d._quantity)), m("div", {
        className: "PointSystemDecorations-item-actions"
      }, equippedNameId === d.id ? m(Button, {
        className: "Button",
        loading: this.busy.has(this.busyKey('name_decoration', d.id)),
        onclick: () => this.unequip('name_decoration', d.id)
      }, app.translator.trans('ramon-point-system.forum.my_decorations.unequip')) : m(Button, {
        className: "Button Button--primary",
        loading: this.busy.has(this.busyKey('name_decoration', d.id)),
        onclick: () => this.equip('name_decoration', d.id, {
          equippedNameDecorationId: d.id,
          equippedNameDecorationSlug: d.slug
        })
      }, app.translator.trans('ramon-point-system.forum.my_decorations.equip'))));
    }))), this.tab === 'title' && titleEnabled && m("section", null, m("h2", null, app.translator.trans('ramon-point-system.forum.my_decorations.custom_title')), ownedTitles.length === 0 && m("p", {
      className: "PointSystemDecorations-empty"
    }, app.translator.trans('ramon-point-system.forum.my_decorations.none')), m("div", {
      className: "PointSystemDecorations-grid"
    }, ownedTitles.map(d => {
      const slug = String(d.slug || '').replace(/[^a-zA-Z0-9_-]/g, '');
      const isEq = equippedTitleId === d.id;
      const styleVar = d.color ? "--ps-title-color:".concat(String(d.color).replace(/[<>"';]/g, ''), ";") : '';
      return m("div", {
        className: "PointSystemDecorations-item ".concat(isEq ? 'is-equipped' : ''),
        key: "ti-".concat(d.id)
      }, m("span", {
        className: "ps-title-preview ps-title-".concat(slug),
        style: styleVar
      }, d.titleText), m("div", {
        className: "PointSystemDecorations-item-name"
      }, d.name, d._quantity > 1 && m("span", {
        className: "PointSystemDecorations-item-quantity"
      }, "\xD7", d._quantity)), m("div", {
        className: "PointSystemDecorations-item-actions"
      }, isEq ? m(Button, {
        className: "Button",
        loading: this.busy.has(this.busyKey('title_decoration', d.id)),
        onclick: () => this.unequip('title_decoration', d.id)
      }, app.translator.trans('ramon-point-system.forum.my_decorations.unequip')) : m(Button, {
        className: "Button Button--primary",
        loading: this.busy.has(this.busyKey('title_decoration', d.id)),
        onclick: () => this.equip('title_decoration', d.id, {
          equippedTitleDecorationId: d.id,
          equippedTitleDecorationSlug: d.slug,
          equippedTitleDecorationText: d.titleText
        })
      }, app.translator.trans('ramon-point-system.forum.my_decorations.equip'))));
    }))), this.tab === 'post-hl' && postHlEnabled && m("section", null, m("h2", null, app.translator.trans('ramon-point-system.forum.my_decorations.post_hl')), ownedPostHls.length === 0 && m("p", {
      className: "PointSystemDecorations-empty"
    }, app.translator.trans('ramon-point-system.forum.my_decorations.none')), m("div", {
      className: "PointSystemDecorations-grid"
    }, ownedPostHls.map(d => {
      const slug = String(d.slug || '').replace(/[^a-zA-Z0-9_-]/g, '');
      const isEq = equippedPostHlId === d.id;
      return m("div", {
        className: "PointSystemDecorations-item ".concat(isEq ? 'is-equipped' : ''),
        key: "ph-".concat(d.id)
      }, m("div", {
        className: "ps-posthl-preview ps-posthl-".concat(slug)
      }, m("div", {
        className: "ps-posthl-preview-avatar"
      }), m("div", {
        className: "ps-posthl-preview-body"
      }, m("div", {
        className: "ps-posthl-preview-line"
      }), m("div", {
        className: "ps-posthl-preview-line short"
      }))), m("div", {
        className: "PointSystemDecorations-item-name"
      }, d.name, d._quantity > 1 && m("span", {
        className: "PointSystemDecorations-item-quantity"
      }, "\xD7", d._quantity)), m("div", {
        className: "PointSystemDecorations-item-actions"
      }, isEq ? m(Button, {
        className: "Button",
        loading: this.busy.has(this.busyKey('post_highlight_decoration', d.id)),
        onclick: () => this.unequip('post_highlight_decoration', d.id)
      }, app.translator.trans('ramon-point-system.forum.my_decorations.unequip')) : m(Button, {
        className: "Button Button--primary",
        loading: this.busy.has(this.busyKey('post_highlight_decoration', d.id)),
        onclick: () => this.equip('post_highlight_decoration', d.id, {
          equippedPostHighlightDecorationId: d.id,
          equippedPostHighlightDecorationSlug: d.slug
        })
      }, app.translator.trans('ramon-point-system.forum.my_decorations.equip'))));
    }))), this.tab === 'cover' && coverEnabled && m("section", null, m("h2", null, app.translator.trans('ramon-point-system.forum.my_decorations.cover')), ownedCovers.length === 0 && m("p", {
      className: "PointSystemDecorations-empty"
    }, app.translator.trans('ramon-point-system.forum.my_decorations.none')), m("div", {
      className: "PointSystemDecorations-coverGrid"
    }, ownedCovers.map(d => m("div", {
      className: "PointSystemDecorations-coverItem ".concat(equippedCoverId === d.id ? 'is-equipped' : ''),
      key: "co-".concat(d.id)
    }, m("div", {
      className: "PointSystemDecorations-coverItem-preview"
    }, m("img", {
      src: this.resolveAsset(d.imageUrl || d.imagePath),
      alt: d.name
    })), m("div", {
      className: "PointSystemDecorations-item-name"
    }, d.name, d._quantity > 1 && m("span", {
      className: "PointSystemDecorations-item-quantity"
    }, "\xD7", d._quantity)), m("div", {
      className: "PointSystemDecorations-item-actions"
    }, equippedCoverId === d.id ? m(Button, {
      className: "Button",
      loading: this.busy.has(this.busyKey('cover_decoration', d.id)),
      onclick: () => this.unequip('cover_decoration', d.id)
    }, app.translator.trans('ramon-point-system.forum.my_decorations.unequip')) : m(Button, {
      className: "Button Button--primary",
      loading: this.busy.has(this.busyKey('cover_decoration', d.id)),
      onclick: () => this.equip('cover_decoration', d.id, {
        equippedCoverDecorationId: d.id,
        equippedCoverDecorationUrl: d.imageUrl || d.imagePath
      })
    }, app.translator.trans('ramon-point-system.forum.my_decorations.equip'))))))));
  }
  navItems(avatarEnabled, nameEnabled, coverEnabled, titleEnabled, postHlEnabled) {
    // See ShopPage.navItems for the bind() rationale.
    const t = app.translator.trans.bind(app.translator);
    const current = this.tab;
    const item = (id, icon, label) => {
      const isActive = current === id;
      const href = app.route('pointSystem.decorations.tab', {
        tab: id
      });
      return m(LinkButton, {
        className: "Button Button--link",
        icon: icon,
        href: href,
        active: isActive,
        itemClassName: isActive ? 'active' : ''
      }, label);
    };
    return [item('all', 'fas fa-th-large', t('ramon-point-system.forum.my_decorations.tab_all')), avatarEnabled ? item('avatar', 'fas fa-user-circle', t('ramon-point-system.forum.my_decorations.avatar')) : null, nameEnabled ? item('name', 'fas fa-font', t('ramon-point-system.forum.my_decorations.name')) : null, coverEnabled ? item('cover', 'fas fa-image', t('ramon-point-system.forum.my_decorations.cover')) : null, titleEnabled ? item('title', 'fas fa-id-badge', t('ramon-point-system.forum.my_decorations.custom_title')) : null, postHlEnabled ? item('post-hl', 'fas fa-highlighter', t('ramon-point-system.forum.my_decorations.post_hl')) : null];
  }
  async equip(type, id, optimistic) {
    const key = this.busyKey(type, id);
    this.busy.add(key);
    m.redraw();
    try {
      const apiUrl = (app.forum.attribute('apiUrl') || '/api').replace(/\/+$/, '');
      await app.request({
        method: 'POST',
        url: "".concat(apiUrl, "/point-system/equip"),
        body: {
          type,
          id
        }
      });
      app.session.user.pushAttributes(optimistic);
    } catch (e) {
      var _e$response;
      app.alerts.show({
        type: 'error'
      }, (e == null || (_e$response = e.response) == null || (_e$response = _e$response.errors) == null || (_e$response = _e$response[0]) == null ? void 0 : _e$response.detail) || 'Error');
    } finally {
      this.busy.delete(key);
      m.redraw();
    }
  }
  async unequip(type, id) {
    const key = this.busyKey(type, id);
    this.busy.add(key);
    m.redraw();
    try {
      const apiUrl = (app.forum.attribute('apiUrl') || '/api').replace(/\/+$/, '');
      await app.request({
        method: 'POST',
        url: "".concat(apiUrl, "/point-system/unequip"),
        body: {
          type
        }
      });
      if (type === 'avatar_decoration') {
        app.session.user.pushAttributes({
          equippedAvatarDecorationId: null,
          equippedAvatarDecorationUrl: null
        });
      } else if (type === 'cover_decoration') {
        app.session.user.pushAttributes({
          equippedCoverDecorationId: null,
          equippedCoverDecorationUrl: null
        });
      } else if (type === 'title_decoration') {
        app.session.user.pushAttributes({
          equippedTitleDecorationId: null,
          equippedTitleDecorationSlug: null,
          equippedTitleDecorationText: null
        });
      } else if (type === 'post_highlight_decoration') {
        app.session.user.pushAttributes({
          equippedPostHighlightDecorationId: null,
          equippedPostHighlightDecorationSlug: null
        });
      } else {
        app.session.user.pushAttributes({
          equippedNameDecorationId: null,
          equippedNameDecorationSlug: null
        });
      }
    } catch (e) {
      var _e$response2;
      app.alerts.show({
        type: 'error'
      }, (e == null || (_e$response2 = e.response) == null || (_e$response2 = _e$response2.errors) == null || (_e$response2 = _e$response2[0]) == null ? void 0 : _e$response2.detail) || 'Error');
    } finally {
      this.busy.delete(key);
      m.redraw();
    }
  }

  // Builds the live-preview block — modelled after Avocado's profile hero
  // and Flarum's UserCard. Cover banner + large framed avatar + decorated
  // username + optional custom title chip. Lets the user see EXACTLY how
  // they'll appear on their own profile page before equipping/changing
  // decorations.
  renderLivePreview(user, equippedNameSlug) {
    var _user$attribute, _user$attribute2, _user$attribute3, _user$attribute4, _user$attribute5, _user$displayName, _user$username;
    const coverPath = (_user$attribute = user.attribute) == null ? void 0 : _user$attribute.call(user, 'equippedCoverDecorationUrl');
    const titleSlug = String(((_user$attribute2 = user.attribute) == null ? void 0 : _user$attribute2.call(user, 'equippedTitleDecorationSlug')) || '').replace(/[^a-zA-Z0-9_-]/g, '');
    const titleText = (_user$attribute3 = user.attribute) == null ? void 0 : _user$attribute3.call(user, 'equippedTitleDecorationText');
    const balance = Number((_user$attribute4 = (_user$attribute5 = user.attribute) == null ? void 0 : _user$attribute5.call(user, 'pointBalance')) != null ? _user$attribute4 : 0);
    const currencyIcon = app.forum.attribute('pointSystem.currency_icon') || 'fas fa-coins';
    const coverUrl = coverPath ? this.resolveAsset(String(coverPath)) : '';
    // CSS custom property carrying the cover URL — matches the same
    // `--ps-cover-url` plumbing the global cover-decoration rule uses on
    // .UserCard / .UserHero / .AvocadoUserPage-hero (see less/forum.less).
    const heroStyle = coverUrl ? "--ps-cover-url: url(\"".concat(safeCssUrl(coverUrl), "\")") : '';

    // Standalone hero — no surrounding `<section class="PointSystemDecorations-preview">`
    // and no "Live preview" heading. The hero is its own self-contained
    // representation of the user's current decorations, matching the
    // hero element on the public profile.
    return m("div", {
      className: "PointSystemDecorations-previewHero UserHero ".concat(coverUrl ? 'ps-has-cover' : ''),
      style: heroStyle
    }, m("div", {
      className: "PointSystemDecorations-previewHero-inner"
    }, m("div", {
      className: "PointSystemDecorations-previewHero-avatar"
    }, m(Avatar, {
      user: user
    })), m("div", {
      className: "PointSystemDecorations-previewHero-meta"
    }, m("h3", {
      className: "PointSystemDecorations-previewHero-name ".concat(equippedNameSlug ? "ps-name-".concat(equippedNameSlug) : '')
    }, m("span", {
      className: "username ps-name-text"
    }, ((_user$displayName = user.displayName) == null ? void 0 : _user$displayName.call(user)) || ((_user$username = user.username) == null ? void 0 : _user$username.call(user)))), titleText && titleSlug && m("span", {
      className: "PointSystemUserTitle ps-title-".concat(titleSlug, " PointSystemUserTitle--inPreview")
    }, titleText), m("div", {
      className: "PointSystemDecorations-previewHero-stats"
    }, m("span", {
      className: "PointSystemProfilePill"
    }, m("i", {
      className: currencyIcon,
      "aria-hidden": "true"
    }), " ", balance.toLocaleString(), " ", pointsLabel(app))))));
  }

  // Maps the current tab to the JSON:API type that SubmitDecorationModal
  // expects. Returns null for the "all" tab (no implicit type).
  currentSubmitType() {
    const tab = this.tab;
    if (tab === 'all') return null;
    return {
      avatar: 'avatar_decoration',
      name: 'name_decoration',
      cover: 'cover_decoration',
      title: 'title_decoration',
      'post-hl': 'post_highlight_decoration'
    }[tab];
  }
  resolveAsset(path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    const base = app.forum.attribute('assetsBaseUrl') || app.forum.attribute('baseUrl') + '/assets';
    return base.replace(/\/+$/, '') + '/' + String(path).replace(/^\/+/, '');
  }

  // Composite preview matching the shop card: user's avatar on the bottom,
  // the decoration frame layered on top. Reuses the shop's existing
  // `.PointSystemShop-avatarPreview` LESS so the two pages render the same
  // shape.
  avatarPreview(d) {
    var _app$session$user, _app$session$user$ava;
    const src = d.imageUrl || d.imagePath || '';
    const url = src ? this.resolveAsset(String(src)) : '';
    const userAvatarUrl = (_app$session$user = app.session.user) == null || (_app$session$user$ava = _app$session$user.avatarUrl) == null ? void 0 : _app$session$user$ava.call(_app$session$user);
    return m("div", {
      className: "PointSystemShop-avatarPreview PointSystemDecorations-avatarPreview"
    }, userAvatarUrl ? m("img", {
      className: "PointSystemShop-avatarPreview-img",
      src: userAvatarUrl,
      alt: ""
    }) : m("span", {
      className: "PointSystemShop-avatarPreview-placeholder",
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-user"
    })), url && m("img", {
      className: "PointSystemShop-avatarPreview-frame",
      src: url,
      alt: d.name
    }));
  }
}
flarum.reg.add('ramon-point-system', 'forum/components/DecorationsPage', DecorationsPage);